// extracted by mini-css-extract-plugin
export default {"gridFloat":"GridFloat_gridFloat__Ge4Lw","anchorPoint":"GridFloat_anchorPoint__wDWUP","floatingContent":"GridFloat_floatingContent__OjQLd"};